
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audio-bs",
      function () {
        return require("private-next-pages/audio-bs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audio-bs"])
      });
    }
  